export default "__VITE_ASSET__DknFMU_g__"